import { createSelector } from 'reselect';

import { StoreState } from '../types';
import {
  SetUsers,
  SetRoles,
  SetUserError,
  AddUser,
  UpdateUser,
  DeleteUser,
  ClearErrors,
  ADD_USER,
  DELETE_USER,
  UPDATE_USER,
  SET_USERS,
  SET_ROLES,
  SET_USER_ERROR,
  CLEAR_ERRORS
} from '../actions';

// reducers ------------------------------------------------------------------

export default {
  users,
  userError,
  roles
};

export function users(
  state: StoreState['users'],
  action: SetUsers | AddUser | DeleteUser | UpdateUser
) {
  switch (action.type) {
    case ADD_USER:
      return {
        ...state,
        [action.user.user_id]: action.user
      };
    case DELETE_USER:
      const deleteState = { ...state };
      delete deleteState[action.userId];
      return deleteState;
    case UPDATE_USER:
      const updateState = { ...state };
      const updated = {
        ...updateState[action.user.user_id],
        ...action.user
      };
      updateState[action.user.user_id] = updated;
      return updateState;
    case SET_USERS:
      return action.users.reduce((usersObj, user) => {
        usersObj[user.user_id] = user;
        return usersObj;
      }, {});
    default:
      return state || null;
  }
}

export function roles(state: StoreState['roles'], action: SetRoles) {
  switch (action.type) {
    case SET_ROLES:
      return action.roles;
    default:
      return state || null;
  }
}

export function userError(
  state: StoreState['userError'],
  action: SetUserError | ClearErrors
) {
  switch (action.type) {
    case SET_USER_ERROR:
      return action.error || null;
    case CLEAR_ERRORS:
      return null;
    default:
      return state || null;
  }
}

// selectors -----------------------------------------------------------------

export function getRoles(state: StoreState) {
  return state.roles;
}

export function getUsers(state: StoreState) {
  return state.users;
}

export function getUserError(state: StoreState) {
  return state.userError;
}

export const getUserIds = createSelector(getUsers, usrs => {
  return usrs ? Object.keys(usrs) : null;
});



// WEBPACK FOOTER //
// ./src/reducers/user.ts